import React from 'react'

const ChipMenuOption = ({
  children,
  className,
  activeClassName = 'text-gray-1100',
  isActive,
  onClick
}) => {
  const classNames = `h-[36px] font-medium text-sm tracking-[0.15px] px-3 py-1.5 rounded-full transition-all duration-3000 ease-in-out text-gray-800 ${className} ${
    isActive ? activeClassName : ''
  }`
  return (
    <button
      className={classNames}
      onClick={onClick}
    >
      {children}
    </button>
  )
}

export default ChipMenuOption
